module.exports = __webpack_public_path__ + "img/3_no.73df11dd.svg";